var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4955",
    "data-name": "Grupo 4955",
    transform: "translate(-10183 -4949)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_145",
    "data-name": "Elipse 145",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(10183 4949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-youtube",
    "data-name": "Icon ionic-logo-youtube",
    d: "M27.874,9.148A4.26,4.26,0,0,0,23.818,4.7c-3.036-.142-6.133-.2-9.3-.2h-.987c-3.157,0-6.259.055-9.3.2A4.27,4.27,0,0,0,.192,9.158c-.137,1.951-.2,3.9-.192,5.853s.055,3.9.186,5.859a4.275,4.275,0,0,0,4.05,4.467c3.19.148,6.462.214,9.788.208q5,.016,9.788-.208a4.275,4.275,0,0,0,4.056-4.467c.132-1.957.192-3.908.186-5.864Q28.071,12.08,27.874,9.148ZM11.345,20.388V9.619L19.291,15Z",
    transform: "translate(10194 4958.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtCircle);
export default __webpack_public_path__ + "static/media/YT-circle.8ed1434bccb2b81a3c2ff457e29e4696.svg";
export { ForwardRef as ReactComponent };